import { render, staticRenderFns } from "./ClientCarrierDetailPage.vue?vue&type=template&id=6d1646fb&scoped=true"
import script from "./ClientCarrierDetailPage.vue?vue&type=script&lang=js"
export * from "./ClientCarrierDetailPage.vue?vue&type=script&lang=js"
import style0 from "./ClientCarrierDetailPage.vue?vue&type=style&index=0&id=6d1646fb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1646fb",
  null
  
)

export default component.exports